import { cva, type VariantProps } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-[var(--phinex-radius-sm)] text-sm font-medium transition-[background-color,color,box-shadow,opacity] duration-[var(--phinex-motion-base)] ease-[var(--phinex-ease-standard)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--phinex-focus-ring)] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary:
          "bg-[var(--phinex-primary)] text-white hover:bg-[var(--phinex-primary-hover)]",
        secondary:
          "border border-[var(--phinex-border)] bg-[var(--phinex-surface)] text-[var(--phinex-text-primary)] hover:bg-[var(--phinex-surface-muted)]",
        ghost:
          "bg-transparent text-[var(--phinex-text-secondary)] hover:bg-[var(--phinex-surface-muted)] hover:text-[var(--phinex-text-primary)]",
        danger:
          "bg-[var(--phinex-negative)] text-white hover:brightness-95",
      },
      size: {
        sm: "h-8 px-3 text-xs",
        md: "h-10 px-4",
        lg: "h-11 px-5",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  },
);

export type ButtonVariantProps = VariantProps<typeof buttonVariants>;
